import { jsx as _jsx } from "react/jsx-runtime";
const ConvertToCurrencySystem = ({ value, currency }) => {
    const currencySymbol = currency ? '₹' : '', absValue = Number(value);
    if (Math.abs(absValue) >= 1.0e9)
        return (_jsx("span", { children: currencySymbol + parseFloat((absValue / 1.0e7).toFixed(2)) + 'Cr' }));
    if (Math.abs(absValue) >= 1.0e6)
        return (_jsx("span", { children: currencySymbol + parseFloat((absValue / 1.0e6).toFixed(2)) + 'M' }));
    if (Math.abs(absValue) >= 1.0e3)
        return (_jsx("span", { children: currencySymbol + parseFloat((absValue / 1.0e3).toFixed(2)) + 'K' }));
    return _jsx("span", { children: parseFloat(absValue.toFixed(2)) });
};
export default ConvertToCurrencySystem;
